// @ts-expect-error [TS migration] Was not detected by flow
import React, { Element } from 'react';
import ChartActions from '../ChartActions/ChartActions';

type Props = {
    children: Element<typeof ChartActions>;
    title: string;
    mediaUrl: string;
};
export default function MediaCard(props: Props): React.ReactElement {
    return (
        <>
            <div className="media-card">
                <iframe
                    src={props.mediaUrl}
                    title={props.title}
                    // @ts-expect-error [TS migration] Was not detected by flow
                    // eslint-disable-next-line react/no-unknown-property
                    allowtransparency="true"
                    frameBorder="0"
                    scrolling="no"
                    className="wistia_embed"
                    name="wistia_embed"
                    allowFullScreen
                    mozallowfullscreen="true"
                    webkitallowfullscreen="true"
                    // eslint-disable-next-line react/no-unknown-property
                    oallowfullscreen="true"
                    // eslint-disable-next-line react/no-unknown-property
                    msallowfullscreen="true"
                />
                <script
                    src="https://fast.wistia.net/assets/external/E-v1.js"
                    async
                />
            </div>
            {props.children}
        </>
    );
}
